import { BaseModel } from "src/app/models/base.model";
import { IUploadedFile } from "src/app/services/file.service";


export interface ITechnicalPlan {
    selection: TechnicalPlanType;
    newRefFile?: IUploadedFile;
    newRefComment?: string;
    updateRefModification?: boolean;
    updateRefFile?: IUploadedFile,
    comment?: string;
}

export enum TechnicalPlanType {
    NEW_REF = "new-ref",
    UPDATE_REF = "update-ref",
    NO_INFO = "no-info"
}

export class TechnicalPlan extends BaseModel<ITechnicalPlan> implements ITechnicalPlan {

    selection: TechnicalPlanType = TechnicalPlanType.NEW_REF;
    newRefFile?: IUploadedFile = undefined;
    newRefComment?: string = undefined;
    updateRefModification?: boolean = false;
    updateRefFile?: IUploadedFile = undefined;
    comment?: string = undefined;

    constructor(data: Partial<TechnicalPlan> = {}) {
        super();
        this.patch(data);
    }
}